import React from "react"
import { NoDataType } from "../constants"
import { CustomEmptyMessage } from "../Table"
import EmptyPlaceholder from "./EmptyPlaceholder"

type Props = {
  isEmpty: boolean
  emptyPlaceholder?: boolean
  totalColumnsCount: number
  emptyPlaceholderType: NoDataType
  renderPlaceholder?: (columns: number) => React.ReactNode
  customEmptyCheck?: () => boolean
  customEmptyMessage?: CustomEmptyMessage
}

const TableEmptyPlaceholder: React.FC<Props> = ({
  isEmpty,
  emptyPlaceholder = true,
  totalColumnsCount,
  emptyPlaceholderType,
  renderPlaceholder,
  customEmptyCheck,
  customEmptyMessage
}) => {
  if (!isEmpty || !emptyPlaceholder) {
    return null
  }

  // If custom renderPlaceholder is provided, use it
  if (renderPlaceholder) {
    return <>{renderPlaceholder(totalColumnsCount)}</>
  }

  // If customEmptyCheck returns true and customEmptyMessage is provided, use it
  if (customEmptyCheck?.() && customEmptyMessage) {
    return (
      <EmptyPlaceholder
        type={emptyPlaceholderType}
        columns={totalColumnsCount}
        customMessage={customEmptyMessage}
      />
    )
  }

  // Default empty placeholder
  return (
    <EmptyPlaceholder type={emptyPlaceholderType} columns={totalColumnsCount} />
  )
}

export default TableEmptyPlaceholder
